import React from 'react'

import { useSelector } from 'react-redux'

import { PagePdf, TemplatesPDF } from '@interco/cp-react-ui-lib'
import { ApplicationState } from '@store/types'
import { formatCurrency } from '@utils/masks'
import { convertStringValueToNumber } from '@utils/functions'

const AutorizacaoLiquidacao = () => {
  const { dadosProposta, numeroProposta } = useSelector(
    (state: ApplicationState) => state.refinanciamento.proposta,
  )

  const variant = 'web'

  return (
    <PagePdf variant={variant}>
      <TemplatesPDF.AutorizacaoLiquidacao
        variant={variant}
        emitente={{
          nome: dadosProposta.nomeCliente ?? '',
          cpf: dadosProposta.cpf ?? '',
          numeroBeneficio: dadosProposta.matricula ?? '',
          documentoIdentificacao: dadosProposta.documentoIdentificacao ?? '',
          endereco:
            dadosProposta.enderecoResidencial && dadosProposta.numeroResidencial
              ? `${dadosProposta.enderecoResidencial}, ${dadosProposta.numeroResidencial}`
              : '',
        }}
        dadosLiquidados={{
          numeroContrato: dadosProposta.contratosRefin[0]?.numeroContratoRefin ?? '',
          liquidacaoEm: new Date().toLocaleDateString('pt-BR'),
          valorSerLiquidado: formatCurrency(
            dadosProposta.saldoDevedorTotalRefin
              ? convertStringValueToNumber(dadosProposta.saldoDevedorTotalRefin)
              : 0,
          ),
        }}
        dadosNovoEmprestimo={{
          numeroProposta: String(numeroProposta),
          valorMutuo: formatCurrency(
            dadosProposta.valorDoMutuo ? convertStringValueToNumber(dadosProposta.valorDoMutuo) : 0,
          ),
          valorTotalFinanciamento: formatCurrency(
            dadosProposta.valorTotalASerPago
              ? convertStringValueToNumber(dadosProposta.valorTotalASerPago)
              : 0,
          ),
          dataEmissao: dadosProposta.dataEmissao ?? new Date().toLocaleDateString('pt-BR'),
          dataPrimeiroVencimento: dadosProposta.primeiroDesconto
            ? new Date(dadosProposta.primeiroDesconto).toLocaleDateString('pt-BR')
            : '',
          dataUltimoVencimento: dadosProposta.ultimoDesconto
            ? new Date(dadosProposta.ultimoDesconto).toLocaleDateString('pt-BR')
            : '',
          quantidadeParcelas: dadosProposta.quantidadeDeParcelas ?? 0,
          valorParcelas: formatCurrency(
            dadosProposta.valorParcela ? convertStringValueToNumber(dadosProposta.valorParcela) : 0,
          ),
          valorTotalSerPago: formatCurrency(
            dadosProposta.valorTotalASerPago
              ? convertStringValueToNumber(dadosProposta.valorTotalASerPago)
              : 0,
          ),
          iof: formatCurrency(
            dadosProposta.valorIOF ? convertStringValueToNumber(dadosProposta.valorIOF) : 0,
          ),
          percentualIof: dadosProposta.percentualIOF ? `${dadosProposta.percentualIOF}%` : '',
          taxaJurosNominal: dadosProposta.taxaNominalContrato
            ? `${dadosProposta.taxaNominalContrato}%`
            : '',
          jurosContratados: formatCurrency(
            dadosProposta.jurosContratados
              ? convertStringValueToNumber(dadosProposta.jurosContratados)
              : 0,
          ),
          percentualJuros: dadosProposta.jurosContratadosPercentual
            ? `${dadosProposta.jurosContratadosPercentual}%`
            : '',
          tarifaCadastro: formatCurrency(
            dadosProposta.tarifaCadastro
              ? convertStringValueToNumber(dadosProposta.tarifaCadastro)
              : 0,
          ),
          percentualTarifaCadastro: dadosProposta.taxaTarifaCadastro
            ? `${dadosProposta.taxaTarifaCadastro}%`
            : '',
          previsaoPrimeiroDesconto: dadosProposta.primeiroDesconto
            ? new Date(dadosProposta.primeiroDesconto).toLocaleDateString('pt-BR')
            : '',
          previsaoUltimoDesconto: dadosProposta.ultimoDesconto
            ? new Date(dadosProposta.ultimoDesconto).toLocaleDateString('pt-BR')
            : '',
          prazoPagamento: `${dadosProposta.quantidadeDeParcelas ?? 0} meses`,
          comissaoPermanencia: dadosProposta.valorTotalDestinadoPagamentoSeguro
            ? formatCurrency(
                convertStringValueToNumber(dadosProposta.valorTotalDestinadoPagamentoSeguro),
              )
            : '',
          cetMensal: dadosProposta.atributosCetMensal ? `${dadosProposta.atributosCetMensal}%` : '',
          cetAnual: dadosProposta.atributosCetAnual ? `${dadosProposta.atributosCetAnual}%` : '',
          seguro: dadosProposta.possuiSeguro ?? false,
          estipulante: dadosProposta.estipulante ?? '',
        }}
        dadosLiberacao={{
          valorLiberacao: formatCurrency(
            dadosProposta.valorLiberado
              ? convertStringValueToNumber(dadosProposta.valorLiberado)
              : 0,
          ),
          banco: dadosProposta.banco ?? '',
          agencia: dadosProposta.agencia ?? '',
          contaCorrente:
            dadosProposta.conta && dadosProposta.digitoContaCorrente
              ? `${dadosProposta.conta}-${dadosProposta.digitoContaCorrente}`
              : dadosProposta.conta ?? '',
          titular: dadosProposta.nomeCliente ?? '',
        }}
      />
    </PagePdf>
  )
}

export default AutorizacaoLiquidacao
